import { Theme } from '@mui/material/styles';

// Type-safe utilities for accessing custom theme palette properties
export const getCustomPaletteColor = (theme: Theme, colorName: string, shade: string) => {
  const colorObject = (theme.palette as any)[colorName];
  return colorObject?.[shade] || '';
};

export const getCustomTextColor = (theme: Theme, shade: string) => {
  const textObject = (theme.palette as any).text;
  return textObject?.[shade] || '';
};

export const getCustomActionColor = (theme: Theme, shade: string) => {
  const actionObject = (theme.palette as any).action;
  return actionObject?.[shade] || '';
};

// Specific helper functions for commonly used custom colors
export const getUtilityColor = (theme: Theme, shade: 'darker' | 'dark' | 'main' | 'light' | 'lighter') => {
  return getCustomPaletteColor(theme, 'utility', shade);
};

export const getSecondaryColor = (theme: Theme, shade: 'darker' | 'dark' | 'main' | 'light' | 'lighter') => {
  return getCustomPaletteColor(theme, 'secondary', shade);
};

export const getContrastTextColor = (theme: Theme, shade: 'contrastPrimary' | 'contrastSecondary' | 'contrastDisabled') => {
  return getCustomTextColor(theme, shade);
};

export const getContrastActionColor = (theme: Theme, shade: 'contrastHover' | 'contrastSelected' | 'contrastActive' | 'contrastFocus') => {
  return getCustomActionColor(theme, shade);
};